import { useState, useEffect, Fragment } from "react";
import { ITableUI } from "../../TableTemplate/tableTemplate";
import { IPermissionsTableReport } from "../../../Interfaces/roleAndPermissionsInterfaces";
import { CommonTableUI } from "../../TableTemplate/common";
import "./style.css";

const TableUI: React.FC<ITableUI<IPermissionsTableReport>> = ({
  reports,
  onAction,
}: ITableUI<IPermissionsTableReport>) => {
  const [rootReports, setRootReports] = useState<
    IPermissionsTableReport[] | null
  >(null);

  const [expandedReport, setExpandedReport] = useState(-1);

  const getChildren = (id: number, tableReports: IPermissionsTableReport[]) => {
    return tableReports.filter((tr) => id === tr.parentId);
  };

  const getNonRootElements = (
    tableReports: IPermissionsTableReport[],
    length: number
  ): IPermissionsTableReport[] => {
    const res: IPermissionsTableReport[] = [];
    tableReports.forEach((tr) => {
      if (tr.parentId)
        res.push({
          ...tr,
          children: getChildren(tr.id, tableReports),
        } as IPermissionsTableReport);
    });

    const newLength = res.length;
    if (newLength !== length) return getNonRootElements(res, newLength);

    return res;
  };

  const convertToTreeView = (tableReports: IPermissionsTableReport[]) => {
    const res: IPermissionsTableReport[] = [];
    tableReports.forEach((r) => {
      if (!r.parentId)
        res.push({
          ...r,
          parent: null,
          children: getNonRootElements(
            tableReports,
            tableReports.length
          ).filter((tr) => tr.parentId === r.id),
        } as IPermissionsTableReport);
    });
    setRootReports(res);
  };

  useEffect(() => {
    if (reports) convertToTreeView(reports.report);
  }, [reports]);

  return (
    <div className="max-h-[calc(100dvh-230px)] max-w-full overflow-auto">
      <table className="permissions-table">
        <thead>
          <tr>
            <th>نام دسترسی</th>
            <th>نام فارسی</th>
            <th>آدرس</th>
            <th>سر گروه</th>
          </tr>
        </thead>
        {rootReports?.map((r) => (
          <tbody key={r.id + r.parentId}>
            <tr
              onClick={() =>
                setExpandedReport(r.id === expandedReport ? -1 : r.id)
              }
            >
              <td>{r.name}</td>
              <td>{r.faName}</td>
              <td>{r.clientAddress}</td>
              <td>{r.parentFaName}</td>
            </tr>
            {r.children.map((child) => (
              <tr
                key={r.id + r.parentId}
                className={`accordion cursor-pointer bg-gray-100 transition-all duration-300 ${
                  expandedReport === r.id ? "active" : ""
                }`}
              >
                <td>{child.name}</td>
                <td>{child.faName}</td>
                <td>{child.clientAddress}</td>
                <td>{child.parentFaName}</td>
              </tr>
            ))}
          </tbody>
        ))}
      </table>
    </div>
  );
};
export default TableUI;
